import { Navigate, Route, Routes } from 'react-router'
import { observer } from 'mobx-react-lite'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { DiscoverRoutes } from 'pages/discover/route/type'
import { DiscoverPath } from 'pages/discover/route/discoverPath'
import { SectionsPage } from 'pages/discover/ui/SectionsPage/SectionsPage'
import { DiscoverLayout } from '../layout/DiscoverLayout'

const DiscoverRouter = observer(() => {
  const { usersStore } = useEntitiesContext()

  if (usersStore.user?.isViewOnlyRole) {
    return (
      <Routes>
        <Route path={'*'} element={<Navigate to={'/'} replace />} />
      </Routes>
    )
  }

  return (
    <Routes>
      <Route element={<DiscoverLayout />}>
        <Route index element={<Navigate to={`/${DiscoverPath.capture}`} replace />} />
        <Route path={DiscoverRoutes.capture} element={<SectionsPage page={'capture'} />} />
        <Route path={DiscoverRoutes.connect} element={<SectionsPage page={'connect'} />} />
        <Route path={DiscoverRoutes.convert} element={<SectionsPage page={'convert'} />} />
        <Route path={DiscoverRoutes.care} element={<SectionsPage page={'care'} />} />
        <Route path='*' element={<Navigate to={`/${DiscoverPath.capture}`} replace />} />
      </Route>
    </Routes>
  )
})

export default DiscoverRouter
